import React, { createContext, useContext } from "react";

type ClearChatCtx = { clearChat: () => void };

const ClearChatContext = createContext<ClearChatCtx | undefined>(undefined);

export const ClearChatProvider: React.FC<{ children: React.ReactNode; clearChat: () => void }> = ({ children, clearChat }) => {
    return <ClearChatContext.Provider value={{ clearChat }}>{children}</ClearChatContext.Provider>;
};

export const useClearChat = () => {
    const ctx = useContext(ClearChatContext);
    if (!ctx) throw new Error("useClearChat must be used within a ClearChatProvider");
    return ctx.clearChat;
};
